/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

import styled from 'styled-components';
import { FontSize } from '../../../../asset/styles';
import { A } from '../../../../../common/primitive';

const StyledNote = styled.div`
  margin: 10px 2px;
  font-size: ${FontSize.tiny};
  color: #828282;

  a {
    color: #bf0000;
    text-decoration: none;
    transition: 0.4s color;

    &:active,
    &:visited {
      color: #960000;
    }
    &:hover,
    &:focus {
      color: #ff1212;
    }
  }

  -webkit-text-size-adjust: 100%;
`;

/**
 * {@link Footer} - 下部 「注釈」 component
 * @param {string} text 注釈文字列
 * @param {string} link プライバシーポリシーへのリンク文字列
 * @param {string} htmlText 注釈+プライバシーポリシーへのリンク HTML文字列
 * @param {string} [className=''] 識別用 class name
 * @param {*} props React.props
 * @return {*} React.node - {@link Footer} - 下部 「注釈」 component
 * @constructor
 */
const FooterNote = ({ text, link, htmlText, className = '' }) => {
  // console.log('FooterNote - text', text, 'htmlText: ', htmlText);
  return htmlText ? (
    <StyledNote
      className={`FooterNote ${className}`}
      dangerouslySetInnerHTML={{ __html: htmlText }}
    />
  ) : (
    <StyledNote className={`FooterNote ${className}`}>
      <span>{text}</span>
      {link && (
        <span>
          個人情報の取り扱いに関しては
          <A href={link} target="_blank">
            こちら
          </A>
          をご確認ください。
        </span>
      )}
    </StyledNote>
  );
};

export default FooterNote;



// WEBPACK FOOTER //
// ./src/phase2/survey/page/inquiry/node/footer/FooterNote.js